import { ContactsApiProvider } from './contactsapi.services';

const fetchMethods = (userName) => {
  return ContactsApiProvider.post('login/members/contactmethods', userName);
};

const sendValidationCode = (validationCode) => {
  return ContactsApiProvider.post('login/members/sendvalidationcode', validationCode);
};

const validateCode = (validationCode) => {
  return ContactsApiProvider.post('login/members/validatecode', validationCode);
};

const sendNewCredentials = (credentials) => {
  return ContactsApiProvider.post('login/members/password', credentials);
};

export const LoginApiProvider = {
  fetchMethods,
  sendValidationCode,
  validateCode,
  sendNewCredentials

};
